import React from 'react'
import { useTranslation } from 'react-i18next'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pImg1 from '../../images/pillars/1.jpeg'
import pImg2 from '../../images/pillars/2.jpeg'
import pImg3 from '../../images/pillars/3.jpeg'
import pImg4 from '../../images/pillars/4.jpeg'
import pImg5 from '../../images/pillars/5.jpeg'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";


const Pillars = [
    { Pimg: pImg1, key: "shahada" },
    { Pimg: pImg2, key: "salah" },
    { Pimg: pImg3, key: "sawm" },
    { Pimg: pImg4, key: "zakat" },
    { Pimg: pImg5, key: "hajj" },
]

const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                centerPadding: '0',
                infinite: true,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        }
    ]
};



const PillarsSection = (props) => {

    const { t } = useTranslation("home");
    const [open, setOpen] = React.useState(false);

    return (

        <section className={`pillars-section section-padding ${props.plClass}`}>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8 col-12">
                        <div className="section-title">
                            <h2>{t("pillars.title")}</h2>
                            <h3>{t("pillars.subtitle")}</h3>
                        </div>
                    </div>
                </div>
                <div className="pillars-wrap">
                    <div className="pillars-slider">
                        <Slider {...settings}>
                            {Pillars.map((image, i) => (
                                <div className="pillars-card" key={i}>
                                    <div className="image" onClick={() => setOpen(true)}>
                                        <img src={image.Pimg} alt="" className="img img-responsive" />
                                        <div className="popup-icon">
                                            <i className="ti-plus"></i>
                                        </div>
                                    </div>
                                    <h3>
                                        {t(`pillars.items.${image.key}`)}
                                    </h3>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[
                    { src: pImg1 },
                    { src: pImg2 },
                    { src: pImg3 },
                    { src: pImg4 },
                    { src: pImg5 },
                ]}
            />
        </section>
    )
}

export default PillarsSection;